(function () {
  function debounce(callback, delay) {
    var timer = null;

    return function () {
      var context = this;
      var args = arguments;

      window.clearTimeout(timer);

      timer = window.setTimeout(function () {
        callback.apply(context, args);
      }, delay);
    };
  }

  /**
   * 清理复制内容中的 Shopify 编辑器属性。
   * 复制出来的卡片只用于视觉循环。
   */
  function prepareClone(group) {
    if (!group) return;

    group.setAttribute("aria-hidden", "true");
    group.dataset.reviewClone = "true";

    group
      .querySelectorAll(
        "a, button, input, select, textarea, [tabindex]"
      )
      .forEach(function (element) {
        element.setAttribute("tabindex", "-1");
      });

    group
      .querySelectorAll("[data-shopify-editor-block]")
      .forEach(function (element) {
        element.removeAttribute(
          "data-shopify-editor-block"
        );
      });

    group.removeAttribute("data-shopify-editor-block");
  }

  /**
   * 重建单独一排。
   */
  function rebuildRow(row) {
    if (!row) return;

    var track = row.querySelector(
      "[data-review-track]"
    );

    if (!track) return;

    var groups = Array.prototype.slice.call(
      track.querySelectorAll(
        ":scope > .review-marquee__group"
      )
    );

    if (!groups.length) return;

    var sourceGroup = groups[0];

    /*
     * 先停止动画。
     */
    track.classList.remove("is-ready");
    track.style.setProperty(
      "--review-loop-distance",
      "0px"
    );

    /*
     * 删除之前由 JS 复制出来的内容。
     * 始终只使用第一组作为原始内容。
     */
    groups.slice(1).forEach(function (group) {
      group.remove();
    });

    sourceGroup.removeAttribute("aria-hidden");
    delete sourceGroup.dataset.reviewClone;

    var sourceWidth =
      sourceGroup.getBoundingClientRect().width;

    var rowWidth =
      row.getBoundingClientRect().width;

    if (
      !sourceWidth ||
      sourceWidth <= 0 ||
      !rowWidth ||
      rowWidth <= 0
    ) {
      return;
    }

    /*
     * 轨道总宽度至少需要：
     * 可视区域宽度 + 两个完整原始组。
     */
    var requiredWidth =
      rowWidth + sourceWidth * 2;

    var cloneCount = 0;
    var maximumClones = 40;

    while (
      track.scrollWidth < requiredWidth &&
      cloneCount < maximumClones
    ) {
      var clone = sourceGroup.cloneNode(true);

      prepareClone(clone);
      track.appendChild(clone);

      cloneCount += 1;
    }

    /*
     * 再增加一个安全组，
     * 防止浏览器缩放和小数像素产生细小空隙。
     */
    var safetyClone =
      sourceGroup.cloneNode(true);

    prepareClone(safetyClone);
    track.appendChild(safetyClone);

    /*
     * 一次动画只移动第一组的真实宽度。
     */
    track.style.setProperty(
      "--review-loop-distance",
      "-" + sourceWidth + "px"
    );

    window.requestAnimationFrame(function () {
      /*
       * 强制确认动画初始状态。
       */
      void track.offsetWidth;

      track.classList.add("is-ready");
    });
  }

  function rebuildSection(section) {
    if (!section) return;

    section
      .querySelectorAll(".review-marquee__row")
      .forEach(function (row) {
        rebuildRow(row);
      });
  }

  function bindPauseEvents(section) {
    if (
      !section ||
      section.dataset.reviewPauseBound === "true"
    ) {
      return;
    }

    var marquee = section.querySelector(
      ".review-marquee"
    );

    if (!marquee) return;

    section.dataset.reviewPauseBound = "true";

    marquee.addEventListener(
      "mouseenter",
      function () {
        marquee.classList.add("is-paused");
      }
    );

    marquee.addEventListener(
      "mouseleave",
      function () {
        marquee.classList.remove("is-paused");
      }
    );

    marquee.addEventListener(
      "touchstart",
      function () {
        marquee.classList.add("is-paused");
      },
      {
        passive: true
      }
    );

    marquee.addEventListener(
      "touchend",
      function () {
        marquee.classList.remove("is-paused");
      },
      {
        passive: true
      }
    );

    marquee.addEventListener(
      "touchcancel",
      function () {
        marquee.classList.remove("is-paused");
      },
      {
        passive: true
      }
    );
  }

  function initReviewMarquee(section) {
    if (!section) return;

    bindPauseEvents(section);

    var rebuild = debounce(function () {
      rebuildSection(section);
    }, 100);

    section._reviewMarqueeRebuild = rebuild;

    rebuildSection(section);

    /*
     * 监听每一排宽度变化。
     */
    if (
      "ResizeObserver" in window &&
      !section._reviewMarqueeResizeObserver
    ) {
      section._reviewMarqueeResizeObserver =
        new ResizeObserver(function () {
          rebuild();
        });

      section
        .querySelectorAll(".review-marquee__row")
        .forEach(function (row) {
          section._reviewMarqueeResizeObserver.observe(
            row
          );
        });
    }

    /*
     * 图片加载完成后重新测量。
     */
    section
      .querySelectorAll(
        ".review-marquee__group:first-child img"
      )
      .forEach(function (image) {
        if (image.complete) return;

        image.addEventListener(
          "load",
          function () {
            rebuild();
          },
          {
            once: true
          }
        );
      });

    /*
     * 自定义字体加载完成后重新测量。
     */
    if (
      document.fonts &&
      document.fonts.ready
    ) {
      document.fonts.ready.then(function () {
        rebuild();
      });
    }
  }

  function initAllReviewMarquees(root) {
    var searchRoot = root || document;
    var sections = [];

    if (
      searchRoot.matches &&
      searchRoot.matches("[data-review-marquee]")
    ) {
      sections.push(searchRoot);
    }

    searchRoot
      .querySelectorAll("[data-review-marquee]")
      .forEach(function (section) {
        sections.push(section);
      });

    sections.forEach(function (section) {
      if (
        section.dataset.reviewMarqueeReady ===
        "true"
      ) {
        if (section._reviewMarqueeRebuild) {
          section._reviewMarqueeRebuild();
        }

        return;
      }

      section.dataset.reviewMarqueeReady = "true";

      initReviewMarquee(section);
    });
  }

  function destroyReviewMarquee(section) {
    if (!section) return;

    if (section._reviewMarqueeResizeObserver) {
      section._reviewMarqueeResizeObserver.disconnect();
      section._reviewMarqueeResizeObserver = null;
    }

    section._reviewMarqueeRebuild = null;
    section.dataset.reviewMarqueeReady = "false";
  }

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        callback,
        {
          once: true
        }
      );
    } else {
      callback();
    }
  }

  ready(function () {
    initAllReviewMarquees(document);
  });

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAllReviewMarquees(event.target);
    }
  );

  document.addEventListener(
    "shopify:block:select",
    function (event) {
      var section = event.target.closest(
        "[data-review-marquee]"
      );

      if (
        section &&
        section._reviewMarqueeRebuild
      ) {
        section._reviewMarqueeRebuild();
      }
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    function (event) {
      var section = null;

      if (
        event.target.matches &&
        event.target.matches(
          "[data-review-marquee]"
        )
      ) {
        section = event.target;
      } else {
        section = event.target.querySelector(
          "[data-review-marquee]"
        );
      }

      if (section) {
        destroyReviewMarquee(section);
      }
    }
  );
})();